import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

export const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/therapy", label: "The Therapy", id: "therapy" },
  { to: "/training", label: "Training & Qualification", id: "training" },
  { to: "/case-studies", label: "Case Studies", id: "case-studies" },
  { to: "/about", label: "About", id: "about" },
];

const Logo = () => (
  <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
    <span className="w-7 h-7 rounded-full border flex items-center justify-center kh-serif text-sm" style={{ borderColor: "var(--kh-text)" }}>K</span>
    <span className="leading-none">
      <span className="kh-serif block text-xl">Kheiron</span>
      <span className="kh-mono block mt-1" style={{ fontSize: "0.6rem" }}>Therapy · Training</span>
    </span>
  </Link>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md" style={{ background: "color-mix(in oklab, var(--kh-bg) 88%, transparent)", borderBottom: "1px solid var(--kh-border)" }}>
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14 h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden xl:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink key={n.id} to={n.to} end className="kh-link" data-testid={`nav-${n.id}-link`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="hidden xl:block"><Link to="/apply" className="kh-btn-primary" data-testid="header-apply-button">Apply to train <span className="kh-arrow">→</span></Link></div>
        <button className="xl:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="xl:hidden overflow-hidden px-6 sm:px-10" data-testid="mobile-menu">
            <div className="flex flex-col gap-5 py-6">
              {NAV.map((n) => (
                <NavLink key={n.id} to={n.to} end onClick={() => setOpen(false)} className="kh-link text-base self-start" data-testid={`mobile-nav-${n.id}-link`}>{n.label}</NavLink>
              ))}
              <Link to="/apply" onClick={() => setOpen(false)} className="kh-btn-primary self-start" data-testid="mobile-apply-button">Apply to train <span className="kh-arrow">→</span></Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
